var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{ref:_vm.name,attrs:{"id":_vm.id,"options":_vm.dropzoneOptions,"destroyDropzone":false},on:{"vdropzone-sending":_vm.vsending,"vdropzone-success":_vm.vsuccess,"vdropzone-removed-file":_vm.vremoved,"vdropzone-mounted":_vm.vmounted}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d4cb15e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Forms/DropzoneUploadCloud.vue
// module id = null
// module chunks = 